import SearchItem from "./SearchItem";
import TopHeading from "./TopHeading";
import SimpleBarWrap from "./SimpleBarWrap";
import type { ServiceType, Masters } from "~/types";
import { useEnvironment } from "~/context/EnvironmentContext";

const SearchByBiz = ({ masters }: { masters: Masters }) => {
  const serviceTypes = masters.serviceTypes;

  // クエリパラメーターを生成
  const generateQueryParams = (serviceTypeId: string) => {
    const params = new URLSearchParams();
    // NOTE: 本コンポーネントでは単一のidを渡す
    // NOTE: クエリパラメータの受取は複数のidの受取に対応しているためキー名が複数形
    // NOTE: 下記のキー名と変数名にズレが有るように思えるが問題ない
    params.append("service_type_ids", serviceTypeId);
    return params.toString();
  };

  // コンテキストから静的画像バケットのエンドポイントを取得
  const { staticImageBucketEndpoint } = useEnvironment();

  return (
    <section className="my-20 md:my-[104px] md:px-7">
      <div className="md:max-w-[1040px] md:mx-auto">
        <div className="mb-6 sp:px-4 md:mb-8">
          <TopHeading
            text="業態から探す"
            icon="bowl"
            iconBg="secondary"
          ></TopHeading>
        </div>
        <SimpleBarWrap>
          <div className="grid gap-4 sp:grid-cols-[repeat(auto-fill,minmax(146px,1fr))] sp:w-[calc(((146px_+16px)_*_36)_+_16px)] sp:px-4 sp:pb-8 sp:[&_a]:flex-shrink-0 sp:[&_a]:w-[146px] md:grid-cols-[repeat(auto-fill,minmax(195px,1fr))]">
            {serviceTypes.map((serviceType: ServiceType) => (
              <SearchItem
                key={serviceType.id}
                linkUrl={`/list/?${generateQueryParams(serviceType.id)}`}
                imageUrl={`${staticImageBucketEndpoint}/public/top/biz/biz-${serviceType.key}.webp`}
                text={serviceType.name}
              ></SearchItem>
            ))}
          </div>
        </SimpleBarWrap>
      </div>
    </section>
  );
};

export default SearchByBiz;
